"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyNoticeContent = PrivacyNoticeContent;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _useTwoLineMessage2 = require("./useTwoLineMessage");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PRIVACY_SHIELD_ICON = /*#__PURE__*/_react["default"].createElement("svg", {
  className: "shrink-0 text-accent-regular",
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  "aria-hidden": "true"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M8 .8 1.8 3.2v4.9c0 4.3 2.6 7.8 6.2 9.1 3.6-1.3 6.2-4.8 6.2-9.1V3.2L8 .8Z",
  fill: "currentColor"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M5.1 8.2h5.8v4.1H5.1V8.2Z",
  fill: "white"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6.3 8.1V6.7A1.7 1.7 0 0 1 8 5a1.7 1.7 0 0 1 1.7 1.7v1.4",
  stroke: "white",
  strokeWidth: "1.1",
  strokeLinecap: "round"
}));
function PrivacyNoticeContent() {
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var privacyMessage = t('purchase:label.bt_form.privacy_message');
  var link = isExpanded ? t('purchase:label.bt_form.privacy_link_less') : t('purchase:label.bt_form.privacy_link_more');
  var _useTwoLineMessage = (0, _useTwoLineMessage2.useTwoLineMessage)({
      enabled: !isExpanded,
      message: privacyMessage,
      trailingText: link
    }),
    messageRef = _useTwoLineMessage.messageRef,
    visibleMessage = _useTwoLineMessage.visibleMessage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4 flex flex-col gap-[11px] border-t border-gray-200 px-1 pt-8",
    "data-sentry-component": "PrivacyNoticeContent",
    "data-sentry-source-file": "PrivacyNoticeContent.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center gap-1.5"
  }, PRIVACY_SHIELD_ICON, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs font-semibold text-accent-regular"
  }, t('purchase:label.bt_form.privacy_title'))), /*#__PURE__*/_react["default"].createElement("p", {
    ref: messageRef,
    className: "m-0 text-xs leading-[1.45] text-gray-500"
  }, visibleMessage, ' ', /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "inline cursor-pointer whitespace-nowrap border-0 bg-transparent p-0 text-xs font-semibold text-accent-regular underline",
    onClick: function onClick() {
      setIsExpanded(function (expanded) {
        return !expanded;
      });
    }
  }, link)));
}